import styled from '@emotion/styled';
import { ReactNode } from 'react';

import BuyFooterContainer from '../containers/BuyFooterContainer';
import TopScrollButton
  from '../../../../shared/components/PC/Button/TopScrollButton';

const Container = styled.div`
  width: 100%;
  position: relative;
`;

interface Props {
  displayFloatingComponent: boolean;
  children: ReactNode;
}

export default function ProductDetailWrapper({
  displayFloatingComponent,
  children,
}: Props) {
  return (
    <Container>
      {children}
      <BuyFooterContainer isDisplay={displayFloatingComponent} />
      <TopScrollButton isDisplay={displayFloatingComponent} />
    </Container>
  );
}
